export const tags = {
  BeefAndBison: 1,
  Poultry: 2,
  FreshFish: 4,
  CalorieConscious: 791,
  LowFodmap: 666,
  LowCholesterol: 749, // Less Cholesterol
  LowFat: 751, // Less Fat
  HighFiber: 750, // More fiber
  Coconut: 793,
  Beets: 792,
  ServingSizeTwo: 228,
  ServingSizeFour: 230,
  lunch: 48,
  breakfast: 47,
  supplements: 14,
  NoRefrigeration: 199,
  Shellfish: 5,
  CookTime: 164,
  CookPrep: 146,
  CarbConscious: 23,
  LessSugar: 24,
  Lamb: 16,
  TofuAndTempeh: 7,
  HighProtein: 25,
  AntiInflamitory: 242,
  GutFriendly: 243,
  ImmunityBoosting: 244,
  Grill: 151,
  Airfryer: 152,
  Microwave: 153,
  Blender: 154,
  Crockpot: 155,
  Stove: 156,
  Oven: 207,
  LowSodium: 26,
  LowCalorie: 65,
  NoSugar: 186,
  Onions: 61,
  Garlic: 62,
  Mushrooms: 64,
  Cilantro: 165,
  BellPeppers: 166,
  Tomatoes: 167,
  Eggplants: 168,
  Potatoes: 169,
  Fusion: 136,
  Korean: 87,
  Japanese: 86,
  Chinese: 85,
  Thai: 84,
  Italian: 82,
  American: 81,
  Mexican: 80,
  Mediterranean: 79,
  Indian: 78,
  Burritos: 234,
  Tamales: 235,
  Salads: 236,
  Sandwiches: 237,
  Pizza: 238,
  Trays: 239,
  Bowls: 240,
  Soups: 241,
  LessFat: 751,
  LessCholesterol: 749,
  MoreFiber: 750,
  OnlyLowSodium: 900,
  Cals500To650: 660,
} as const;

export type Tags = (typeof tags)[keyof typeof tags];
